module.exports = __webpack_public_path__ + "static/img/B.8ddfa10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leishenx/B.png
// module id = YOa9
// module chunks = 0